
// ドロワーに追加した商品が無い以外最高
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', async function(e) {
    const target = e.target.closest('.js-ajax-cart-link');
    if (!target) return;
    e.preventDefault();

    let items;
    try {
      items = JSON.parse(target.getAttribute('data-items'));
    } catch(e) {
      const variantId = target.getAttribute('data-variant-id');
      const quantity = target.getAttribute('data-quantity') || 1;
      items = [{ id: Number(variantId), quantity: Number(quantity) }];
    }

    try {
      // 1. カートに商品を追加
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      const addData = await addResponse.json();

      // エラーハンドリング (例: 在庫切れなど)
      if (addResponse.status !== 200) {
        console.error('カート追加エラー:', addData.message || addData.description || '不明なエラー');
        alert('カート追加エラー: ' + (addData.description || addData.message || '商品の追加に失敗しました。'));
        return;
      }

      // 2. カートの最新情報を取得
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // 3. カートドロワーとカートバッジのセクションデータをまとめて取得
      const sectionsResponse = await fetch('/cart?sections=cart-drawer,cart-icon-bubble&sections_url=/cart');
      const sectionData = await sectionsResponse.json();

      // 4. カートドロワーを更新して開く
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');

      if (cartDrawer) {
        // カートドロワーの内容を直接更新
        cartDrawer.innerHTML = sectionData['cart-drawer'];
        
        // Shopifyのカスタム要素を再初期化
        if (window.Shopify && window.Shopify.designMode) {
          document.documentElement.dispatchEvent(new CustomEvent('shopify:section:load'));
        }
        
        cartDrawer.open();
      } else if (cartNotification) {
        // 通知の商品情報を更新
        const notificationProduct = document.getElementById('cart-notification-product');
        if (notificationProduct && addData.items) {
          let productsHTML = '';
          
          // 追加された全ての商品を表示
          addData.items.forEach(item => {
            let variantInfo = '';
            
            // バリアント情報の構築
            if (item.variant_title) {
              const variantParts = item.variant_title.split(' / ');
              variantParts.forEach(part => {
                const [name, value] = part.split(': ');
                if (name && value) {
                  variantInfo += `
                    <div class="product-option">
                      <dt>${name}:</dt>
                      <dd>${value}</dd>
                    </div>`;
                }
              });
            }

            productsHTML += `
              <div class="cart-notification-product__item cart-notification-product__item--multi">
                <div class="cart-notification-product__image global-media-settings">
                  <img src="${item.image}&width=140" alt="${item.title}" width="70" height="93" loading="lazy">
                </div>
                <div>
                  <h3 class="cart-notification-product__name h4">${item.title}</h3>
                  <dl>${variantInfo}</dl>
                </div>
              </div>
            `;
          });

          notificationProduct.innerHTML = productsHTML;
        }

        // カートボタンのテキストを更新
        const cartButton = document.getElementById('cart-notification-button');
        if (cartButton) {
          cartButton.textContent = `カートを見る (${cartData.item_count})`;
        }
        
        if (typeof cartNotification.open === 'function') {
          cartNotification.open();
        }
      }

      // 5. カートバッジを更新
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sectionData['cart-icon-bubble'];
      const newBadge = tempDiv.querySelector('.cart-count-bubble');

      if (newBadge) {
        const cartIconWrapper = document.querySelector('.header__icon--cart');

        if (cartIconWrapper) {
          const oldBadge = cartIconWrapper.querySelector('.cart-count-bubble');

          if (oldBadge) {
            oldBadge.replaceWith(newBadge);
          } else {
            cartIconWrapper.appendChild(newBadge);
          }
          
          if (newBadge.classList.contains('hidden')) {
              newBadge.classList.remove('hidden');
          }
          if (newBadge.getAttribute('aria-hidden') === 'true') {
              newBadge.removeAttribute('aria-hidden');
          }
        }
      }

    } catch (err) {
      console.error('カート操作エラー:', err);
    }
  });
});


